import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref, reactive, } from 'vue'
import { ElMessage } from 'element-plus'
import type { ElForm } from 'element-plus'
import { updatePassword } from '@/api/jurisdiction';
type FormInstance = InstanceType<typeof ElForm>


export default /*@__PURE__*/_defineComponent({
  __name: 'Personal',
  setup(__props, { expose: __expose }) {

const dialogVisible = ref(false)
const show = () => {
  ruleForm.password = null
  dialogVisible.value = true
}
const hide = () => {
  dialogVisible.value = false
}
const formSize = ref('')
const ruleFormRef = ref<FormInstance>()
const ruleForm = reactive({
  password: null,
})
const rules = reactive({
  password: [
    {
      required: true,
      message: '请输入密码',
      trigger: 'blur',
    },
  ],
})
const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate((valid) => {
    if (valid) {
      updatePassword(ruleForm).then(
        res => {
          // @ts-ignore：
          if (res.code == 0) {
            ElMessage({
              showClose: true,
              // @ts-ignore：
              message: "已成功重置密码",
              type: 'success',
            })
            hide()
          } else {
            ElMessage({
              showClose: true,
              // @ts-ignore：
              message: res.message,
              type: 'error',
            })
          }
        }
      )
    } else {
      console.log('error submit!')
      return false
    }
  })
}

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.resetFields()
}

__expose({
  show,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
    title: "修改密码",
    width: "30%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(ruleFormRef.value)))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        rules: rules,
        "label-width": "120px",
        class: "demo-ruleForm",
        size: formSize.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "重置密码",
            prop: "password"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: ruleForm.password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.password) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "size"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})